

























import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
	name: 'DateTimeInput',

	components: {
		FlatPickr,
	},

	props: {
		label: {
			required: true,
			type: String,
		},
		placeholder: {
			required: false,
			type: String,
		},
		value: {
			required: false,
			type: [Date, String],
		},
		error: {
			default: '',
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
		},
		min: {
			default: null,
			required: false,
			type: [String, Date],
		},
		small: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data() {
		return {
			datetime: this.value ? new Date(this.value).toLocaleDateString() : this.value,
		};
	},

	created() {
		this.datetime = this.value;
	},

	watch: {
		datetime() {
			let d = new Date(this.datetime).toISOString().replace('T', ' ').replace(':00.000Z', '');

			this.$emit('input', d);
		},
	},

	computed: {
		config() {
			return {
				enableTime: true,
				dateFormat: 'Y-m-d H:i',
				altFormat: 'Y-m-d H:i',
				altInput: true,
				minDate: this.min,
				disableMobile: true,
			};
		},
	},
};
